/* eslint-disable react/jsx-pascal-case */
import { Button, Col, Form, Row, Modal } from "./../..//../components/ui/ot";
import React, { useEffect, useState } from "react";
import ChatroomAdmin from "./ChatroomAdmin";


const ChatroomAdminModal = (
    {
        axiosMode = "post",
        propsOpen = null,
        propsLoading = null,
        sendData={},
        propsSetOpen = () => {

        }    }
) => {

    const axiosModelanguage = {
        post: "新增",
        patch: "修改"
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
    };

    const handleCancel = () => {
        closeModal()
    };
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])
    return (
        <>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}資料`
                    }
                </Button>
            }

            <Modal
                width={600}
                title={`歷史紀錄`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Row >
                    <Col span={24}>
                        <ChatroomAdmin
                        sendData ={sendData}
                        />
                    </Col>
                </Row>
            </Modal>
        </>

    )
}


export default ChatroomAdminModal;
